export enum FormButtonType {
    Submit = "submit",
    Next = "next",
    Back = "prev",
    Modal = "modal",
}
